// extracted by mini-css-extract-plugin
export default {"button":"lwh5W","button-disabled":"Ajokc"};